/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-16 06:14:58
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';
import { CollectionType } from 'src/models/filter-data';
import type {
  FilterOptionValuesType,
  FilterOptionValueCombinationsType,
  TopCollectionsTotalFilterClicksType,
  CollectionTotalDetailsByTimeFilterClicksType,
  SearchTermsType,
  TotalSearchesType,
  ChartSourceType,
  TotalFilterClicksOnSearchType,
  AnalyticsSettingsType
} from 'src/models/analytics';

export const GET_ANALYTICS_SETTINGS_REQUEST = 'GET_ANALYTICS_SETTINGS_REQUEST';
type GET_ANALYTICS_SETTINGS_REQUEST_TYPE = 'GET_ANALYTICS_SETTINGS_REQUEST';

export const GET_ANALYTICS_SETTINGS_SUCCESS = 'GET_ANALYTICS_SETTINGS_SUCCESS';
type GET_ANALYTICS_SETTINGS_SUCCESS_TYPE = 'GET_ANALYTICS_SETTINGS_SUCCESS';

export const GET_ANALYTICS_SETTINGS_FAILURE = 'GET_ANALYTICS_SETTINGS_FAILURE';
type GET_ANALYTICS_SETTINGS_FAILURE_TYPE = 'GET_ANALYTICS_SETTINGS_FAILURE';

export const UPDATE_ANALYTICS_SETTINGS_REQUEST = 'UPDATE_ANALYTICS_SETTINGS_REQUEST';
type UPDATE_ANALYTICS_SETTINGS_REQUEST_TYPE = 'UPDATE_ANALYTICS_SETTINGS_REQUEST';

export const UPDATE_ANALYTICS_SETTINGS_SUCCESS = 'UPDATE_ANALYTICS_SETTINGS_SUCCESS';
type UPDATE_ANALYTICS_SETTINGS_SUCCESS_TYPE = 'UPDATE_ANALYTICS_SETTINGS_SUCCESS';

export const UPDATE_ANALYTICS_SETTINGS_FAILURE = 'UPDATE_ANALYTICS_SETTINGS_FAILURE';
type UPDATE_ANALYTICS_SETTINGS_FAILURE_TYPE = 'UPDATE_ANALYTICS_SETTINGS_FAILURE';

export const GET_TOTAL_REQUEST = 'GET_TOTAL_REQUEST';
type GET_TOTAL_REQUEST_TYPE = 'GET_TOTAL_REQUEST';

export const GET_TOTAL_SUCCESS = 'GET_TOTAL_SUCCESS';
type GET_TOTAL_SUCCESS_TYPE = 'GET_TOTAL_SUCCESS';

export const GET_TOTAL_FAILURE = 'GET_TOTAL_FAILURE';
type GET_TOTAL_FAILURE_TYPE = 'GET_TOTAL_FAILURE';

export const GET_TOTAL_ALL_SALES_REQUEST = 'GET_TOTAL_ALL_SALES_REQUEST';
type GET_TOTAL_ALL_SALES_REQUEST_TYPE = 'GET_TOTAL_ALL_SALES_REQUEST';

export const GET_TOTAL_ALL_SALES_SUCCESS = 'GET_TOTAL_ALL_SALES_SUCCESS';
type GET_TOTAL_ALL_SALES_SUCCESS_TYPE = 'GET_TOTAL_ALL_SALES_SUCCESS';

export const GET_TOTAL_ALL_SALES_FAILURE = 'GET_TOTAL_ALL_SALES_FAILURE';
type GET_TOTAL_ALL_SALES_FAILURE_TYPE = 'GET_TOTAL_ALL_SALES_FAILURE';

export const GET_TOP_FILTER_OPTION_VALUES_REQUEST = 'GET_TOP_FILTER_OPTION_VALUES_REQUEST';
type GET_TOP_FILTER_OPTION_VALUES_REQUEST_TYPE = 'GET_TOP_FILTER_OPTION_VALUES_REQUEST';

export const GET_TOP_FILTER_OPTION_VALUES_SUCCESS = 'GET_TOP_FILTER_OPTION_VALUES_SUCCESS';
type GET_TOP_FILTER_OPTION_VALUES_SUCCESS_TYPE = 'GET_TOP_FILTER_OPTION_VALUES_SUCCESS';

export const GET_TOP_FILTER_OPTION_VALUES_FAILURE = 'GET_TOP_FILTER_OPTION_VALUES_FAILURE';
type GET_TOP_FILTER_OPTION_VALUES_FAILURE_TYPE = 'GET_TOP_FILTER_OPTION_VALUES_FAILURE';

export const GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_REQUEST =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_REQUEST';
type GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_REQUEST_TYPE =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_REQUEST';

export const GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_SUCCESS =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_SUCCESS';
type GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_SUCCESS_TYPE =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_SUCCESS';

export const GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_FAILURE =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_FAILURE';
type GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_FAILURE_TYPE =
  'GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_FAILURE';

export const CHANGE_VALUE = 'CHANGE_VALUE';
type CHANGE_VALUE_TYPE = 'CHANGE_VALUE';

type GetTotalSuccess = {
  totalFilters: number,
  totalSearches: number
};

type GetTotalAllSalesSuccess = {
  totalSales: number
};

type GetTopFilterOptionValuesSuccess = {
  data: FilterOptionValuesType
};

type GetTopFilterOptionValueCombinationsSuccess = {
  data: FilterOptionValueCombinationsType
};

type AnalyticsSettingsSuccess = {
  data: AnalyticsSettingsType
};

type AnalyticFailure = {
  error: any
};

type GetAnalyticsSettingsRequestAction = Action<GET_ANALYTICS_SETTINGS_REQUEST_TYPE, null>;

type GetAnalyticsSettingsSuccessAction = Action<
  GET_ANALYTICS_SETTINGS_SUCCESS_TYPE,
  AnalyticsSettingsSuccess
>;

type GetAnalyticsSettingsFailureAction = Action<
  GET_ANALYTICS_SETTINGS_FAILURE_TYPE,
  AnalyticFailure
>;

type UpdateAnalyticsSettingsRequestAction = Action<UPDATE_ANALYTICS_SETTINGS_REQUEST_TYPE, null>;

type UpdateAnalyticsSettingsSuccessAction = Action<
  UPDATE_ANALYTICS_SETTINGS_SUCCESS_TYPE,
  AnalyticsSettingsSuccess
>;

type UpdateAnalyticsSettingsFailureAction = Action<
  UPDATE_ANALYTICS_SETTINGS_FAILURE_TYPE,
  AnalyticFailure
>;

type GetTotalRequestAction = Action<GET_TOTAL_REQUEST_TYPE, null>;

type GetTotalSuccessAction = Action<GET_TOTAL_SUCCESS_TYPE, GetTotalSuccess>;

type GetTotalFailureAction = Action<GET_TOTAL_FAILURE_TYPE, AnalyticFailure>;

type GetTotalAllSalesRequestAction = Action<GET_TOTAL_ALL_SALES_REQUEST_TYPE, null>;

type GetTotalAllSalesSuccessAction = Action<
  GET_TOTAL_ALL_SALES_SUCCESS_TYPE,
  GetTotalAllSalesSuccess
>;

type GetTotalAllSalesFailureAction = Action<GET_TOTAL_ALL_SALES_FAILURE_TYPE, AnalyticFailure>;

type GetTopFilterOptionValuesRequestAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_REQUEST_TYPE,
  null
>;

type GetTopFilterOptionValuesSuccessAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_SUCCESS_TYPE,
  GetTopFilterOptionValuesSuccess
>;

type GetTopFilterOptionValuesFailureAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_FAILURE_TYPE,
  AnalyticFailure
>;

type GetTopFilterOptionValueCombinationsRequestAction = Action<
  GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_REQUEST_TYPE,
  null
>;

type GetTopFilterOptionValueCombinationsSuccessAction = Action<
  GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_SUCCESS_TYPE,
  GetTopFilterOptionValueCombinationsSuccess
>;

type GetTopFilterOptionValueCombinationsFailureAction = Action<
  GET_TOP_FILTER_OPTION_VALUE_COMBINATIONS_FAILURE_TYPE,
  AnalyticFailure
>;

// Top collections total for filter clicks
export const GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_REQUEST =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_REQUEST';
type GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_REQUEST_TYPE =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_REQUEST';

export const GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_SUCCESS =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_SUCCESS';
type GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_SUCCESS_TYPE =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_SUCCESS';

export const GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_FAILURE =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_FAILURE';
type GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_FAILURE_TYPE =
  'GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_FAILURE';

type GetTopCollectionsTotalFilterClicksSuccess = {
  data: TopCollectionsTotalFilterClicksType
};

type GetTopCollectionsTotalFilterClicksRequestAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_REQUEST_TYPE,
  null
>;

type GetTopCollectionsTotalFilterClicksSuccessAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_SUCCESS_TYPE,
  GetTopCollectionsTotalFilterClicksSuccess
>;

type GetTopCollectionsTotalFilterClicksFailureAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_FILTER_CLICKS_FAILURE_TYPE,
  AnalyticFailure
>;

// Collection total details by time for filter clicks
export const GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_REQUEST =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_REQUEST';
type GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_REQUEST_TYPE =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_REQUEST';

export const GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_SUCCESS =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_SUCCESS';
type GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_SUCCESS_TYPE =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_SUCCESS';

export const GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_FAILURE =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_FAILURE';
type GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_FAILURE_TYPE =
  'GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_FAILURE';

type GetCollectionTotalDetailsByTimeFilterClicksSuccess = {
  data: CollectionTotalDetailsByTimeFilterClicksType
};

type GetCollectionTotalDetailsByTimeFilterClicksRequestAction = Action<
  GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_REQUEST_TYPE,
  null
>;

type GetCollectionTotalDetailsByTimeFilterClicksSuccessAction = Action<
  GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_SUCCESS_TYPE,
  GetCollectionTotalDetailsByTimeFilterClicksSuccess
>;

type GetCollectionTotalDetailsByTimeFilterClicksFailureAction = Action<
  GET_COLLECTION_TOTAL_DETAILS_BY_TIME_FILTER_CLICKS_FAILURE_TYPE,
  AnalyticFailure
>;

export const GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_REQUEST =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_REQUEST';
type GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_REQUEST_TYPE =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_REQUEST';

export const GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_SUCCESS =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_SUCCESS';
type GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_SUCCESS_TYPE =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_SUCCESS';

export const GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_FAILURE =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_FAILURE';
type GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_FAILURE_TYPE =
  'GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_FAILURE';

type GetTopFilterOptionValuesOnSearchPageRequestAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_REQUEST_TYPE,
  null
>;

type GetTopFilterOptionValuesOnSearchPageSuccessAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_SUCCESS_TYPE,
  GetTopFilterOptionValuesSuccess
>;

type GetTopFilterOptionValuesOnSearchPageFailureAction = Action<
  GET_TOP_FILTER_OPTION_VALUES_ON_SEARCH_PAGE_FAILURE_TYPE,
  AnalyticFailure
>;

// Top search terms
export const GET_TOP_SEARCH_TERMS_REQUEST = 'GET_TOP_SEARCH_TERMS_REQUEST';
type GET_TOP_SEARCH_TERMS_REQUEST_TYPE = 'GET_TOP_SEARCH_TERMS_REQUEST';

export const GET_TOP_SEARCH_TERMS_SUCCESS = 'GET_TOP_SEARCH_TERMS_SUCCESS';
type GET_TOP_SEARCH_TERMS_SUCCESS_TYPE = 'GET_TOP_SEARCH_TERMS_SUCCESS';

export const GET_TOP_SEARCH_TERMS_FAILURE = 'GET_TOP_SEARCH_TERMS_FAILURE';
type GET_TOP_SEARCH_TERMS_FAILURE_TYPE = 'GET_TOP_SEARCH_TERMS_FAILURE';

type GetTopSearchTermsSuccess = {
  data: SearchTermsType
};

type GetTopSearchTermsRequestAction = Action<
  GET_TOP_SEARCH_TERMS_REQUEST_TYPE,
  { noResult: boolean }
>;

type GetTopSearchTermsSuccessAction = Action<
  GET_TOP_SEARCH_TERMS_SUCCESS_TYPE,
  GetTopSearchTermsSuccess
>;

type GetTopSearchTermsFailureAction = Action<GET_TOP_SEARCH_TERMS_FAILURE_TYPE, AnalyticFailure>;

// Total searches
export const GET_TOTAL_SEARCHES_REQUEST = 'GET_TOTAL_SEARCHES_REQUEST';
type GET_TOTAL_SEARCHES_REQUEST_TYPE = 'GET_TOTAL_SEARCHES_REQUEST';

export const GET_TOTAL_SEARCHES_SUCCESS = 'GET_TOTAL_SEARCHES_SUCCESS';
type GET_TOTAL_SEARCHES_SUCCESS_TYPE = 'GET_TOTAL_SEARCHES_SUCCESS';

export const GET_TOTAL_SEARCHES_FAILURE = 'GET_TOTAL_SEARCHES_FAILURE';
type GET_TOTAL_SEARCHES_FAILURE_TYPE = 'GET_TOTAL_SEARCHES_FAILURE';

type GetTotalSearchesSuccess = {
  data: TotalSearchesType
};

type GetTotalSearchesRequestAction = Action<GET_TOTAL_SEARCHES_REQUEST_TYPE, { noResult: boolean }>;

type GetTotalSearchesSuccessAction = Action<
  GET_TOTAL_SEARCHES_SUCCESS_TYPE,
  GetTotalSearchesSuccess
>;

type GetTotalSearchesFailureAction = Action<GET_TOTAL_SEARCHES_FAILURE_TYPE, AnalyticFailure>;

// Total filter clicks on search page
export const GET_TOTAL_FILTER_CLICKS_ON_SEARCH_REQUEST =
  'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_REQUEST';
type GET_TOTAL_FILTER_CLICKS_ON_SEARCH_REQUEST_TYPE = 'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_REQUEST';

export const GET_TOTAL_FILTER_CLICKS_ON_SEARCH_SUCCESS =
  'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_SUCCESS';
type GET_TOTAL_FILTER_CLICKS_ON_SEARCH_SUCCESS_TYPE = 'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_SUCCESS';

export const GET_TOTAL_FILTER_CLICKS_ON_SEARCH_FAILURE =
  'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_FAILURE';
type GET_TOTAL_FILTER_CLICKS_ON_SEARCH_FAILURE_TYPE = 'GET_TOTAL_FILTER_CLICKS_ON_SEARCH_FAILURE';

type GetTotalFilterClicksOnSearchSuccess = {
  data: TotalFilterClicksOnSearchType
};

type GetTotalFilterClicksOnSearchRequestAction = Action<
  GET_TOTAL_FILTER_CLICKS_ON_SEARCH_REQUEST_TYPE,
  { noResult: boolean }
>;

type GetTotalFilterClicksOnSearchSuccessAction = Action<
  GET_TOTAL_FILTER_CLICKS_ON_SEARCH_SUCCESS_TYPE,
  GetTotalFilterClicksOnSearchSuccess
>;

type GetTotalFilterClicksOnSearchFailureAction = Action<
  GET_TOTAL_FILTER_CLICKS_ON_SEARCH_FAILURE_TYPE,
  AnalyticFailure
>;

type ChangeValueAction = Action<CHANGE_VALUE_TYPE, { name: string, value: any }>;

// Top collections total for sales
export const GET_TOP_COLLECTIONS_TOTAL_SALES_REQUEST = 'GET_TOP_COLLECTIONS_TOTAL_SALES_REQUEST';
type GET_TOP_COLLECTIONS_TOTAL_SALES_REQUEST_TYPE = 'GET_TOP_COLLECTIONS_TOTAL_SALES_REQUEST';

export const GET_TOP_COLLECTIONS_TOTAL_SALES_SUCCESS = 'GET_TOP_COLLECTIONS_TOTAL_SALES_SUCCESS';
type GET_TOP_COLLECTIONS_TOTAL_SALES_SUCCESS_TYPE = 'GET_TOP_COLLECTIONS_TOTAL_SALES_SUCCESS';

export const GET_TOP_COLLECTIONS_TOTAL_SALES_FAILURE = 'GET_TOP_COLLECTIONS_TOTAL_SALES_FAILURE';
type GET_TOP_COLLECTIONS_TOTAL_SALES_FAILURE_TYPE = 'GET_TOP_COLLECTIONS_TOTAL_SALES_FAILURE';

type GetTopCollectionsTotalSalesSuccess = {
  data: TopCollectionsTotalSalesType
};

type GetTopCollectionsTotalSalesRequestAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_SALES_REQUEST_TYPE,
  null
>;

type GetTopCollectionsTotalSalesSuccessAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_SALES_SUCCESS_TYPE,
  GetTopCollectionsTotalSalesSuccess
>;

type GetTopCollectionsTotalSalesFailureAction = Action<
  GET_TOP_COLLECTIONS_TOTAL_SALES_FAILURE_TYPE,
  AnalyticFailure
>;

// Collection total sales by time
export const GET_TOTAL_SALES_REQUEST = 'GET_TOTAL_SALES_REQUEST';
type GET_TOTAL_SALES_REQUEST_TYPE = 'GET_TOTAL_SALES_REQUEST';

export const GET_TOTAL_SALES_SUCCESS = 'GET_TOTAL_SALES_SUCCESS';
type GET_TOTAL_SALES_SUCCESS_TYPE = 'GET_TOTAL_SALES_SUCCESS';

export const GET_TOTAL_SALES_FAILURE = 'GET_TOTAL_SALES_FAILURE';
type GET_TOTAL_SALES_FAILURE_TYPE = 'GET_TOTAL_SALES_FAILURE';

type GetTotalSalesSuccess = {
  data: CollectionTotalDetailsByTimeSalesType
};

type GetTotalSalesRequestAction = Action<GET_TOTAL_SALES_REQUEST_TYPE, null>;

type GetTotalSalesSuccessAction = Action<GET_TOTAL_SALES_SUCCESS_TYPE, GetTotalSalesSuccess>;

type GetTotalSalesFailureAction = Action<GET_TOTAL_SALES_FAILURE_TYPE, AnalyticFailure>;

// Collection total sales by time
export const GET_TOTAL_SALES_ON_SEARCH_REQUEST = 'GET_TOTAL_SALES_ON_SEARCH_REQUEST';
type GET_TOTAL_SALES_ON_SEARCH_REQUEST_TYPE = 'GET_TOTAL_SALES_ON_SEARCH_REQUEST';

export const GET_TOTAL_SALES_ON_SEARCH_SUCCESS = 'GET_TOTAL_SALES_ON_SEARCH_SUCCESS';
type GET_TOTAL_SALES_ON_SEARCH_SUCCESS_TYPE = 'GET_TOTAL_SALES_ON_SEARCH_SUCCESS';

export const GET_TOTAL_SALES_ON_SEARCH_FAILURE = 'GET_TOTAL_SALES_ON_SEARCH_FAILURE';
type GET_TOTAL_SALES_ON_SEARCH_FAILURE_TYPE = 'GET_TOTAL_SALES_ON_SEARCH_FAILURE';

type GetTotalSalesOnSearchSuccess = {
  data: CollectionTotalDetailsByTimeSalesType
};

type GetTotalSalesOnSearchRequestAction = Action<GET_TOTAL_SALES_ON_SEARCH_REQUEST_TYPE, null>;

type GetTotalSalesOnSearchSuccessAction = Action<
  GET_TOTAL_SALES_ON_SEARCH_SUCCESS_TYPE,
  GetTotalSalesOnSearchSuccess
>;

type GetTotalSalesOnSearchFailureAction = Action<
  GET_TOTAL_SALES_ON_SEARCH_FAILURE_TYPE,
  AnalyticFailure
>;

// Export data
export const EXPORT_DATA_REQUEST = 'EXPORT_DATA_REQUEST';
type EXPORT_DATA_REQUEST_TYPE = 'EXPORT_DATA_REQUEST';

export const EXPORT_DATA_SUCCESS = 'EXPORT_DATA_SUCCESS';
type EXPORT_DATA_SUCCESS_TYPE = 'EXPORT_DATA_SUCCESS';

export const EXPORT_DATA_FAILURE = 'EXPORT_DATA_FAILURE';
type EXPORT_DATA_FAILURE_TYPE = 'EXPORT_DATA_FAILURE';

type ExportDataRequestAction = Action<EXPORT_DATA_REQUEST_TYPE, null>;

type ExportDataSuccessAction = Action<EXPORT_DATA_SUCCESS_TYPE, { data: Object }>;

type ExportDataFailureAction = Action<EXPORT_DATA_FAILURE_TYPE, AnalyticFailure>;

// Action and State
export type AnalyticsAction =
  | GetAnalyticsSettingsRequestAction
  | GetAnalyticsSettingsSuccessAction
  | GetAnalyticsSettingsFailureAction
  | UpdateAnalyticsSettingsRequestAction
  | UpdateAnalyticsSettingsSuccessAction
  | UpdateAnalyticsSettingsFailureAction
  | GetTotalRequestAction
  | GetTotalSuccessAction
  | GetTotalFailureAction
  | GetTotalAllSalesRequestAction
  | GetTotalAllSalesSuccessAction
  | GetTotalAllSalesFailureAction
  | GetTopFilterOptionValuesRequestAction
  | GetTopFilterOptionValuesSuccessAction
  | GetTopFilterOptionValuesFailureAction
  | GetTopFilterOptionValueCombinationsRequestAction
  | GetTopFilterOptionValueCombinationsSuccessAction
  | GetTopFilterOptionValueCombinationsFailureAction
  | ChangeValueAction
  | GetTopCollectionsTotalFilterClicksRequestAction
  | GetTopCollectionsTotalFilterClicksSuccessAction
  | GetTopCollectionsTotalFilterClicksFailureAction
  | GetCollectionTotalDetailsByTimeFilterClicksRequestAction
  | GetCollectionTotalDetailsByTimeFilterClicksSuccessAction
  | GetCollectionTotalDetailsByTimeFilterClicksFailureAction
  | GetTopFilterOptionValuesOnSearchPageRequestAction
  | GetTopFilterOptionValuesOnSearchPageSuccessAction
  | GetTopFilterOptionValuesOnSearchPageFailureAction
  | GetTopSearchTermsRequestAction
  | GetTopSearchTermsSuccessAction
  | GetTopSearchTermsFailureAction
  | GetTotalSearchesRequestAction
  | GetTotalSearchesSuccessAction
  | GetTotalSearchesFailureAction
  | GetTotalFilterClicksOnSearchRequestAction
  | GetTotalFilterClicksOnSearchSuccessAction
  | GetTotalFilterClicksOnSearchFailureAction
  | GetTopCollectionsTotalSalesRequestAction
  | GetTopCollectionsTotalSalesSuccessAction
  | GetTopCollectionsTotalSalesFailureAction
  | GetTotalSalesRequestAction
  | GetTotalSalesSuccessAction
  | GetTotalSalesFailureAction
  | GetTotalSalesOnSearchRequestAction
  | GetTotalSalesOnSearchSuccessAction
  | GetTotalSalesOnSearchFailureAction
  | ExportDataRequestAction
  | ExportDataSuccessAction
  | ExportDataFailureAction;

export type AnalyticsState = {
  loading: boolean,
  exporting: boolean,
  success: boolean,
  totalFiltersClicks: number,
  totalSearches: number,
  totalSales: number,
  totalQueryExecutionId: string,

  // Settings
  loadingAnalyticsSettings: boolean,
  savingAnalyticsSettings: boolean,
  success: boolean,
  error: any,
  analyticsSettings: AnalyticsSettingsType | {},

  // Filter
  collection: CollectionType,
  fromDate: Date,
  toDate: Date,
  compare: boolean,

  // Collection
  // Top filter option values
  topFilterOptionValuesLoading: boolean,
  topFilterOptionValuesSuccess: boolean,
  topFilterOptionValues: FilterOptionValuesType,
  topFilterOptionValuesQueryExecutionId: string,

  // Top filter option value combinations
  topFilterOptionValueCombinationsLoading: boolean,
  topFilterOptionValueCombinationsSuccess: boolean,
  topFilterOptionValueCombinations: FilterOptionValueCombinationsType,
  topFilterOptionValueCombinationsQueryExecutionId: string,

  // Top collections total for filter clicks
  topCollectionsTotalFilterClicksLoading: boolean,
  topCollectionsTotalFilterClicksSuccess: boolean,
  topCollectionsTotalFilterClicks: Array<Object>,
  topCollectionsTotalFilterClicksQueryExecutionId: string,

  // Collection total details by time for filter clicks
  collectionTotalDetailsByTimeFilterClicksLoading: boolean,
  collectionTotalDetailsByTimeFilterClicksSuccess: boolean,
  collectionTotalDetailsByTimeFilterClicks: ChartSourceType,
  collectionTotalDetailsByTimeFilterClicksCompared: ChartSourceType,
  collectionTotalDetailsByTimeFilterClicksTotal: number,
  collectionTotalDetailsByTimeFilterClicksPercentChange: number,
  collectionTotalDetailsByTimeFilterClicksQueryExecutionId: string,
  collectionTotalDetailsByTimeFilterClicksComparedQueryExecutionId: string,

  // Top collections total sales
  topCollectionsTotalSalesLoading: boolean,
  topCollectionsTotalSalesSuccess: boolean,
  topCollectionsTotalSales: Array<Object>,
  topCollectionsTotalSalesQueryExecutionId: string,

  // Collection total sales by time
  totalSalesLoading: boolean,
  totalSalesSuccess: boolean,
  totalSalesData: ChartSourceType,
  totalSalesCompared: ChartSourceType,
  totalSalesTotal: number,
  totalSalesPercentChange: number,
  totalSalesQueryExecutionId: string,

  // Searchs
  // Top search term
  topSearchTermsLoading: boolean,
  topSearchTermsSuccess: boolean,
  topSearchTerms: SearchTermsType,
  topSearchTermsQueryExecutionId: string,

  // Top search term with no result
  topSearchTermsWithNoResultLoading: boolean,
  topSearchTermsWithNoResultSuccess: boolean,
  topSearchTermsWithNoResult: SearchTermsType,
  topSearchTermsWithNoResultQueryExecutionId: string,

  // Top filter option values on search page
  topFilterOptionValuesOnSearchPageLoading: boolean,
  topFilterOptionValuesOnSearchPageSuccess: boolean,
  topFilterOptionValuesOnSearchPage: FilterOptionValuesType,
  topFilterOptionValuesOnSearchPageQueryExecutionId: string,

  // Total search
  totalSearchesLoading: boolean,
  totalSearchesSuccess: boolean,
  totalSearchesData: TotalSearchesType,
  totalSearchesCompared: TotalSearchesType,
  totalSearchesTotal: number,
  totalSearchesPercentChange: number,
  totalSearchesQueryExecutionId: string,
  totalSearchesComparedQueryExecutionId: string,

  // Total filter clicks on search
  totalFilterClicksOnSearchLoading: boolean,
  totalFilterClicksOnSearchSuccess: boolean,
  totalFilterClicksOnSearch: ChartSourceType,
  totalFilterClicksOnSearchCompared: ChartSourceType,
  totalFilterClicksOnSearchTotal: number,
  totalFilterClicksOnSearchPercentChange: number,
  totalFilterClicksOnSearchQueryExecutionId: string,
  totalFilterClicksOnSearchComparedExecutionId: string,

  // Total sales on search
  totalSalesOnSearchLoading: boolean,
  totalSalesOnSearchSuccess: boolean,
  totalSalesOnSearch: ChartSourceType,
  totalSalesOnSearchCompared: ChartSourceType,
  totalSalesOnSearchTotal: number,
  totalSalesOnSearchPercentChange: number,
  totalSalesOnSearchQueryExecutionId: string
};
